/** @format */

import React, { useState, useEffect } from "react";
import "../../App.css";
import ModalComponent from "./ModalComponent";
import ModalRecibos from "./ModalRecibos";
import { ModalInformacion } from "./ModalInformacion";
import { useSelector, useDispatch } from "react-redux";
import { recargarComponente } from "../../redux/slices/userSlice";
import axios from "axios";

export const CardCurso = ({ cursos, cardTipo }) => {
  const defaultImage = "https://fundacionunam.org/cei/assets/img/junta.jpg";
  const [activeModal, setActiveModal] = useState(null);
  const [idInscripcion, setIdInscripcion] = useState(null);
  const [cursoSeleccionado, setCursoSeleccionado] = useState(null);

  const user = useSelector((state) => state.user.id);
  const path = useSelector((state) => state.sitePath);
  const dispatch = useDispatch();
  const contador = useSelector((state) => state.contador);

  const openModal = (type, idIns, curso = []) => {
    setIdInscripcion(idIns);
    setCursoSeleccionado(curso);
    setActiveModal(type);
  };

  const closeModal = () => {
    setActiveModal(null);
  };

  const handleError = (event) => {
    event.target.onerror = null;
    event.target.src = defaultImage;
  };

  if (!cursos.length || cursos === "Error") {
    return (
      <div className='d-flex justify-content-center'>
        <h4>No hay ningún curso para esta sección</h4>
      </div>
    );
  }

  return (
    <div
      id='cards-container'
      className='row gy-4 aos-init aos-animate'
      data-aos='fade-up'
      data-aos-delay='100'
    >
      {cursos.map((curso, i) => {
        const courseImage = `https://fundacionunam.org/educacion_continua/admin_cursos/imgs_cursos/${curso.id_curso}.jpg`;
        {
          /* console.log(
          parseFloat(curso.costo_final),
          parseFloat(curso.total_monto_pagos)
        ); */
        }
        return (
          <div
            key={`${curso.id_curso}-${i}`}
            className='col-xl-3 d-flex justify-content-center'
          >
            <div className='card card-custom'>
              <div className='position-relative'>
                <a
                  href='#'
                  className='card-title-link'
                  data-id='{item.id}'
                >
                  <img
                    id={"curso" + curso.id_curso}
                    src={courseImage}
                    onError={handleError}
                    className='img-fluid'
                    alt='Card image'
                  />
                </a>
                <div className='badge-container'>
                  <span className='badge badge-info'>{curso?.modalidad}</span>
                  <span className='badge badge-primary'>{curso?.tipo}</span>
                </div>
              </div>
              <div className='card-body'>
                <h4 className='card-title two-lines'>
                  <a
                    href='#'
                    className='card-title-link'
                    data-id={curso.id}
                  >
                    {curso.curso}
                  </a>
                </h4>

                <div>
                  <h6>
                    Fecha: {curso?.fecha_inicio} a {curso?.fecha_fin}
                  </h6>
                  <h6>Duración: {curso?.duracion} horas</h6>
                </div>

                <p className='card-text two-lines'>
                  {curso.objetivo ? curso.objetivo : curso.entidad}
                </p>

                {cardTipo === "actuales" && (
                  <div className='d-flex justify-content-center'>
                    <button
                      id={"btnRecibos" + curso.idioma}
                      onClick={() => openModal("recibos", curso.id_ins)}
                      className='btn btn-primary px-4'
                    >
                      Ver recibos
                    </button>
                  </div>
                )}
                {parseFloat(curso.costo_final) >
                  parseFloat(curso.total_monto_pagos) &&
                  cardTipo === "actuales" && (
                    <div className='d-flex justify-content-center'>
                      <button
                        id={"btnInscribirNuevoGrupo" + curso.idioma}
                        onClick={() => openModal("pago", curso.id_ins, curso)}
                        className='btn btn-secondary px-4 my-3'
                      >
                        Hacer Aportación
                      </button>
                    </div>
                  )}
                {cardTipo !== "finalizados" && (
                  <div className='d-flex justify-content-center'>
                    <button
                      id={"btnInformacion" + curso.idioma}
                      onClick={() => openModal("informacion", curso.id, curso)}
                      className='btn btn-secondary px-4 my-3'
                    >
                      Más
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        );
      })}
      {activeModal === "recibos" && (
        <ModalRecibos
          showModal={true}
          closeModal={closeModal}
          idInscripcion={idInscripcion}
          key={contador}
        />
      )}
      {activeModal === "pago" && (
        <ModalComponent
          showModal={true}
          closeModal={closeModal}
          idInscripcion={idInscripcion}
          curso={cursoSeleccionado}
          key={contador}
        />
      )}
      {activeModal === "informacion" && (
        <ModalInformacion
          showModal={true}
          closeModal={closeModal}
          curso={cursoSeleccionado}
          key={contador}
        />
      )}
    </div>
  );
};
